import { render, staticRenderFns } from "./DetailDocument.vue?vue&type=template&id=976207d8&"
import script from "./DetailDocument.vue?vue&type=script&lang=js&"
export * from "./DetailDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports